import { JobMatchesQueryFilter } from "../../../../models/jobMatchesQueryFilter";
var CandidatesInfiniteScrollContainer = /** @class */ (function () {
    function CandidatesInfiniteScrollContainer(workflowStep, workflowStepVariable, uiIdentifier, userId, companyId, jobId, globalQueryFilter, workflowStepNames, jobMatchDragAndDropService, jobMatchService, alertsAndNotificationsService) {
        this.workflowStep = workflowStep;
        this.workflowStepVariable = workflowStepVariable;
        this.uiIdentifier = uiIdentifier;
        this.userId = userId;
        this.companyId = companyId;
        this.jobId = jobId;
        this.globalQueryFilter = globalQueryFilter;
        this.workflowStepNames = workflowStepNames;
        this.jobMatchDragAndDropService = jobMatchDragAndDropService;
        this.jobMatchService = jobMatchService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    CandidatesInfiniteScrollContainer.prototype.$onInit = function () {
        this.candidates = [];
        this.candidatesExistFlag = true;
        this.busy = false;
        this.disableInfiniteScroll = false;
        this.isFilterOn = false;
        this.jobMatchesQueryFilter = new JobMatchesQueryFilter([this.workflowStep]);
        this.jobMatchesQueryFilter.searchString = this.globalQueryFilter.searchString;
        this.jobMatchesQueryFilter.jobMatchIds = this.globalQueryFilter.jobMatchIds;
        this.jobMatchesQueryFilter.isUnassigned = this.globalQueryFilter.isUnassigned;
        this.jobMatchesQueryFilter.isAssignedToOthers = this.globalQueryFilter.isAssignedToOthers;
        this.jobMatchesQueryFilter.isAssignedToMe = this.globalQueryFilter.isAssignedToMe;
        this.jobMatchesQueryFilter.workflowStates = this.globalQueryFilter.workflowStates;
        this.jobMatchesQueryFilter.outreachStateFilters = this.globalQueryFilter.outreachStateFilters;
        this.jobMatchesQueryFilter.vendors = this.globalQueryFilter.vendors;
        this.currentPromise = null;
        this.allowedDnDTypes = this.jobMatchDragAndDropService.getAllowedDraggableTypesOfCurrentWorkflowStep(this.workflowStep, this.workflowStepNames);
        // this.workflowStepVariable = workflowStepVariable;
        this.isCollapsedFlag = false;
        this.showCollapseIconFlag = true;
        this.expandCollapseLabel = 'Collapse Column';
        this.countAndLabelTooltipPlacement = 'bottom-right';
        this.totalCandidateCount = '..';
        this.pageNum = 1;
        this.pageSize = 5;
    };
    CandidatesInfiniteScrollContainer.prototype.getNext = function () {
        var _this = this;
        // var parent = this;
        if (this.busy)
            return;
        this.busy = true;
        this._setIsFilterOn();
        //console.log('filter object in get next -', this.jobMatchesQueryFilter);
        this.currentPromise = this.jobMatchService.getJobMatchCandidates(this.userId, this.companyId, this.pageNum, this.pageSize, this.jobId, this.jobMatchesQueryFilter, function (data) {
            if (angular.isDefined(data) && data != 'user cancellation') {
                _this.totalCandidateCount = data.totalCardCount;
                var candidatesArray = JSON.parse(data[_this.workflowStepVariable]);
                if (candidatesArray.length > 0) {
                    angular.forEach(candidatesArray, function (val, key) {
                        val.selectedFlag = _this.selectAllJobMatchesFlag;
                        val.disabledFlag = false;
                        val.currentStep = _this.workflowStep;
                        // this.candidates.push(angular.merge(new Candidate(), val));
                        _this.setCandidateOutreachDisabled(val);
                        _this.candidates.push(val);
                    });
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if (candidatesArray.length < _this.pageSize) {
                        _this.disableInfiniteScroll = true;
                    }
                    else {
                        _this.pageNum++;
                    }
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    _this.disableInfiniteScroll = true;
                }
            }
            //set this.busy to false
            _this.busy = false;
            // set current promise to null
            _this.currentPromise = null;
            // set the candidates exist flag based on existence of candidates.
            if (_this.candidates.length > 0) {
                _this.candidatesExistFlag = true;
            }
            else {
                _this.candidatesExistFlag = false;
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            _this.busy = false;
            // if there was an error in the get call, we need to disable infinite scroll. Else it will continue indefinitely.
            _this.disableInfiniteScroll = true;
            // set current promise to null
            _this.currentPromise = null;
        });
    };
    CandidatesInfiniteScrollContainer.prototype._setIsFilterOn = function () {
        var filter = this.jobMatchesQueryFilter;
        if (filter.jobMatchIds.length > 0
            || filter.workflowStates.length > 0
            || filter.vendors.length > 0
            || filter.searchString.length > 0
            || !filter.isAssignedToMe
            || !filter.isAssignedToOthers
            || !filter.isUnassigned) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    };
    CandidatesInfiniteScrollContainer.prototype.setCandidateOutreachDisabled = function (candidate) {
        candidate.isOutreachDisabled = false;
    };
    return CandidatesInfiniteScrollContainer;
}());
export { CandidatesInfiniteScrollContainer };
//# sourceMappingURL=candidates-infinite-scroll-container.js.map